import type React from 'react';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { IconButton } from '@mui/material';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath, useReactFlow } from '@xyflow/react';

import type { EdgeProps } from '@xyflow/react';

export const EdgeDeleteButton = ({ x, y, id }: { x: number; y: number; id: string }): React.ReactElement => {
  const reactFlowInstance = useReactFlow();

  const onEdgeClick = (event: React.MouseEvent, id: string): void => {
    event.stopPropagation();
    void reactFlowInstance.deleteElements({ edges: [{ id }] });
  };

  return (
    <div
      style={{
        position: 'absolute',
        zIndex: 6000,
        transform: `translate(-50%, -50%) translate(${x}px,${y}px)`,
        fontSize: 12,
        // everything inside EdgeLabelRenderer has no pointer events by default
        // if you have an interactive element, set pointer-events: all
        pointerEvents: 'all',
      }}
      className='nodrag nopan'
    >
      <IconButton
        size='small'
        data-testid='edge-button'
        className='edge-button'
        onClick={(event) => {
          onEdgeClick(event, id);
        }}
      >
        <CloseRoundedIcon />
      </IconButton>
    </div>
  );
};

export default function CallflowEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  selected,
}: EdgeProps): React.ReactElement {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  const calculatedEdgePath = edgePath;
  const calculatedLabelX = labelX;
  const calculatedLabelY = labelY;

  return (
    <>
      <BaseEdge path={calculatedEdgePath} markerEnd={markerEnd} style={style} />
      {selected === true && (
        <>
          <EdgeLabelRenderer>
            <EdgeDeleteButton x={calculatedLabelX} y={calculatedLabelY} id={id} />
          </EdgeLabelRenderer>
        </>
      )}
    </>
  );
}
